<div class="card" *ngIf="workflow">

    <!-- Header -->
    <div class="flex justify-content-between align-items-center mb-4">
        <div>
            <h2 class="m-0 mb-2">Configuração do Workflow</h2>
            <p class="text-600 m-0">{{ formatarNomeEntidade(workflow.entidade) }}</p>
        </div>
        <div class="flex gap-2">
            <p-button
                label="Cancelar"
                icon="pi pi-times"
                severity="secondary"
                [outlined]="true"
                (onClick)="voltar()">
            </p-button>
            <p-button
                label="Salvar"
                icon="pi pi-check"
                [loading]="loading"
                (onClick)="salvar()">
            </p-button>
        </div>
    </div>

    <div class="grid">
        <!-- Coluna Esquerda - Informações Básicas -->
        <div class="col-12 lg:col-6">
            <div class="card shadow-1">
                <h5 class="mt-0 mb-4">Informações Básicas</h5>

                <div class="p-fluid">
                    <!-- Nome -->
                    <div class="field mb-4">
                        <label for="nome">Nome *</label>
                        <input
                            id="nome"
                            type="text"
                            pInputText
                            [(ngModel)]="nome"
                            [class.p-invalid]="mostrarErros && nome.trim().length === 0"
                            placeholder="Digite o nome do workflow">
                        <small class="p-error" *ngIf="mostrarErros && nome.trim().length === 0">
                            Campo obrigatório
                        </small>
                    </div>

                    <!-- Descrição -->
                    <div class="field mb-4">
                        <label for="descricao">Descrição *</label>
                        <textarea
                            id="descricao"
                            pInputTextarea
                            [(ngModel)]="descricao"
                            rows="4"
                            [class.p-invalid]="mostrarErros && descricao.trim().length === 0"
                            placeholder="Digite a descrição do workflow">
                        </textarea>
                        <small class="p-error" *ngIf="mostrarErros && descricao.trim().length === 0">
                            Campo obrigatório
                        </small>
                    </div>

                    <!-- Aprovação Automática -->
                    <div class="field mb-4">
                        <div class="flex align-items-center">
                            <p-inputSwitch [(ngModel)]="aprovacaoAutomatica" inputId="aprovacaoAutomatica"></p-inputSwitch>
                            <label for="aprovacaoAutomatica" class="ml-2 mb-0">Aprovação Automática</label>
                        </div>
                        <small class="text-500">
                            Quando ativado, as requisições deste workflow serão aprovadas automaticamente
                        </small>
                    </div>

                    <!-- Notifica Email -->
                    <div class="field mb-4">
                        <div class="flex align-items-center">
                            <p-inputSwitch [(ngModel)]="notificaEmail" inputId="notificaEmail"></p-inputSwitch>
                            <label for="notificaEmail" class="ml-2 mb-0">Notificar por Email</label>
                        </div>
                        <small class="text-500">
                            Quando ativado, notificações por email serão enviadas para os aprovadores
                        </small>
                    </div>
                </div>

                <!-- Informações de Auditoria -->
                <div class="mt-4 p-3 bg-blue-50 border-round">
                    <h6 class="mt-0 mb-3 text-blue-900">Informações de Auditoria</h6>
                    <div class="grid text-sm">
                        <div class="col-6">
                            <div class="text-500">Criado Por</div>
                            <div class="font-semibold">{{ workflow.criadoPor }}</div>
                        </div>
                        <div class="col-6">
                            <div class="text-500">Criado Em</div>
                            <div class="font-semibold">{{ workflow.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</div>
                        </div>
                        <div class="col-6" *ngIf="workflow.atualizadoPor">
                            <div class="text-500">Atualizado Por</div>
                            <div class="font-semibold">{{ workflow.atualizadoPor }}</div>
                        </div>
                        <div class="col-6" *ngIf="workflow.atualizadoEm">
                            <div class="text-500">Atualizado Em</div>
                            <div class="font-semibold">{{ workflow.atualizadoEm | date: 'dd/MM/yyyy HH:mm' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Coluna Direita - Etapas e Aprovadores -->
        <div class="col-12 lg:col-6">
            <div class="card shadow-1">
                <div class="flex justify-content-between align-items-center mb-4">
                    <h5 class="m-0">Etapas e Aprovadores</h5>
                </div>

                <div *ngIf="loadingEtapas" class="text-center p-4">
                    <i class="pi pi-spin pi-spinner text-3xl text-primary"></i>
                    <p class="text-500 mt-2">Carregando etapas...</p>
                </div>

                <div *ngIf="!loadingEtapas && etapas.length === 0" class="text-center p-4 border-1 border-dashed border-300 border-round">
                    <i class="pi pi-info-circle text-3xl text-400"></i>
                    <p class="text-500 mt-2 mb-0">Nenhuma etapa configurada para este workflow</p>
                </div>

                <div *ngIf="!loadingEtapas && etapas.length > 0" class="flex flex-column gap-3">
                    <div *ngFor="let etapa of etapas; let i = index"
                         class="p-3 border-1 border-300 border-round bg-white">
                        <div class="flex justify-content-between align-items-start mb-3">
                            <div class="flex-1">
                                <div class="flex align-items-center gap-2 mb-2">
                                    <p-tag [value]="'Etapa ' + etapa.ordem" severity="info"></p-tag>
                                    <span class="font-semibold">{{ etapa.nome }}</span>
                                </div>
                                <p class="text-500 text-sm mb-2">{{ etapa.descricao }}</p>
                                <div class="flex gap-3 text-sm text-600">
                                    <span>
                                        <i class="pi pi-users mr-1"></i>
                                        Mínimo de aprovações: <strong>{{ etapa.minimoAprovacao }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Aprovadores -->
                        <div class="mt-3 pt-3 border-top-1 border-200">
                            <div class="flex justify-content-between align-items-center mb-3">
                                <span class="text-sm font-semibold text-700">Aprovadores ({{ etapa.aprovadores.length }})</span>
                                <p-button
                                    *ngIf="!isEtapaEmEdicao(etapa.id)"
                                    icon="pi pi-pencil"
                                    label="Editar Aprovadores"
                                    size="small"
                                    [text]="true"
                                    severity="info"
                                    (onClick)="toggleEdicaoEtapa(etapa)">
                                </p-button>
                            </div>

                            <!-- Modo Visualização -->
                            <div *ngIf="!isEtapaEmEdicao(etapa.id)">
                                <div *ngIf="etapa.aprovadores.length === 0" class="text-center p-3 bg-gray-50 border-round">
                                    <p class="text-500 text-sm mb-0">Nenhum aprovador configurado</p>
                                </div>

                                <div *ngIf="etapa.aprovadores.length > 0" class="flex flex-column gap-2">
                                    <div *ngFor="let aprovador of etapa.aprovadores"
                                         class="flex justify-content-between align-items-center p-2 bg-gray-50 border-round">
                                        <div class="flex align-items-center gap-2">
                                            <i class="pi pi-user text-primary"></i>
                                            <span class="text-sm font-semibold">{{ aprovador.nomeUsuario }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Modo Edição -->
                            <div *ngIf="isEtapaEmEdicao(etapa.id)">
                                <!-- Adicionar aprovador -->
                                <div class="field mb-3">
                                    <label class="block mb-2">Adicionar Aprovador</label>
                                    <div class="flex gap-2">
                                        <p-dropdown
                                            [(ngModel)]="usuarioParaAdicionar"
                                            [options]="usuariosDisponiveis"
                                            optionLabel="nomeUsuario"
                                            placeholder="Selecione um usuário"
                                            [filter]="true"
                                            filterBy="nomeUsuario"
                                            [showClear]="true"
                                            styleClass="flex-1">
                                            <ng-template let-usuario pTemplate="item">
                                                <div class="flex align-items-center gap-2">
                                                    <i class="pi pi-user"></i>
                                                    <span>{{ usuario.nomeUsuario }}</span>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                        <p-button
                                            icon="pi pi-plus"
                                            label="Adicionar"
                                            [disabled]="!usuarioParaAdicionar"
                                            (onClick)="adicionarAprovador()">
                                        </p-button>
                                    </div>
                                </div>

                                <!-- Lista de aprovadores -->
                                <div class="mb-3">
                                    <label class="block mb-2">Aprovadores Selecionados ({{ aprovadoresSelecionados.length }})</label>

                                    <div *ngIf="aprovadoresSelecionados.length === 0" class="text-center p-3 bg-gray-50 border-round">
                                        <i class="pi pi-info-circle text-400 text-xl"></i>
                                        <p class="text-500 text-sm mt-2 mb-0">Nenhum aprovador selecionado</p>
                                    </div>

                                    <div *ngIf="aprovadoresSelecionados.length > 0" class="flex flex-column gap-2">
                                        <div *ngFor="let aprovador of aprovadoresSelecionados"
                                             class="flex justify-content-between align-items-center p-2 border-1 border-300 border-round bg-white">
                                            <div class="flex align-items-center gap-2">
                                                <i class="pi pi-user text-primary"></i>
                                                <span class="text-sm font-semibold">{{ aprovador.nomeUsuario }}</span>
                                            </div>
                                            <p-button
                                                icon="pi pi-trash"
                                                [rounded]="true"
                                                [text]="true"
                                                severity="danger"
                                                size="small"
                                                (onClick)="removerAprovador(aprovador)"
                                                pTooltip="Remover aprovador"
                                                tooltipPosition="top">
                                            </p-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Botões de ação -->
                                <div class="flex justify-content-end gap-2 pt-3 border-top-1 border-200">
                                    <p-button
                                        label="Cancelar"
                                        icon="pi pi-times"
                                        size="small"
                                        severity="secondary"
                                        [outlined]="true"
                                        (onClick)="cancelarEdicao()">
                                    </p-button>
                                    <p-button
                                        label="Salvar"
                                        icon="pi pi-check"
                                        size="small"
                                        [loading]="loading"
                                        (onClick)="salvarAprovadores(etapa)">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Loading state -->
<div *ngIf="!workflow && loading" class="card text-center p-5">
    <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
    <p class="text-500 mt-3">Carregando workflow...</p>
</div>
